


























































import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Button from "@/components/Button.vue";
import Logo from "@/components/Logo.vue";
import HomeIcon from "@/assets/icons/HomeIcon.vue";
import ProfileIcon from "@/assets/icons/ProfileIcon.vue";
import LogoffIcon from "@/assets/icons/LogoffIcon.vue";
import MenuIcon from "@/assets/icons/MenuIcon.vue";
import { Form } from "../../interfaces";
import ClipboardIcon from "../../assets/icons/ClipboardIcon.vue";

@Component({
  components: {
    appLogo: Logo,
    appButton: Button,
    appMenuIcon: MenuIcon,
    appHomeIcon: HomeIcon,
    appClipboardIcon: ClipboardIcon,
    appProfileIcon: ProfileIcon,
    appLogoffIcon: LogoffIcon,
  },
})
export default class Dashboard extends Vue {
  @Action("logout", { namespace: "auth" }) logout!: () => void;
  @Action("getForms", { namespace: "form" }) getForms!: () => void;
  @Getter("allForms", { namespace: "form" }) allForms!: Array<Form>;

  isSidebarOpen = false;

  mounted() {
    this.getForms();
  }

  @Watch("$route")
  onRouteChange() {
    this.isSidebarOpen = false;
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  get isAnyFormNotAnswered(): boolean {
    return this.allForms.filter((form) => form.answered === false).length > 0;
  }
}
